<script>import { viewState } from "./page";
import Loader from "./Loader.svelte";
import Renderer from "./Renderer.svelte";
</script>

<Loader />
<Renderer components={$viewState}></Renderer>
